export const createCategoryStructure = (paramObj) => {
  const { categories, products } = paramObj;
  const assignProduct =
    typeof paramObj.assignProduct === 'undefined' ? true : paramObj.assignProduct;
  
  // array sorting; should be done with strapi
  categories.sort((a, b) => {
    if (a.category_ID < b.category_ID) {
      return -1;
    }
    if (a.category_ID > b.category_ID) {
      return 1;
    }
    return 0;
  });
  
  let temp = categories.map((category) => ({
    parentCategory: category.parent_category,
    id: category.category_ID,
    children: [],
  }));

  const findMatchedCategory = (parms) => {
    let result = null;
    temp.forEach(category => {
      if(result){
        return;
      }
      if(category.id === parms.id) {
        result = category;
      }
    });
    return result;
  };

  temp.forEach((category) => {
    if (category.parentCategory) {
      const parent = findMatchedCategory({
        id: category.parentCategory.category_ID
      });
      if(parent){
        parent.children.push(category);
      }
    }
  });

  if (assignProduct) {
    products.forEach((product) => {
      if (!product.categories) return;

      product.categories.forEach((productCategory) => {
        const match = findMatchedCategory({
          id: productCategory.category_ID
        });

        if(match){
          match.children.push({
            product
          });
        }
      })
    });
  }

  return temp.filter((category) => !category.parentCategory);
};

export const getItemById = (paramObj) => {
  const { id, array, key } = paramObj;
  for (let i = 0; i < array.length; i += 1) {
    if (id === array[i][key]) {
      return array[i];
    }
  }
  return null;
};

// bulma specification - mobile max 768px
// bulma specification - tablet 769px
// bulma specification - desktop 1024px
export const isMobile = () => typeof window !== 'undefined' ? window.matchMedia('only screen and (max-width: 767px)').matches : false;

export const isTablet = () =>
  typeof window !== 'undefined' ? window.matchMedia('only screen and (min-width: 767px) and (max-width: 1023px)').matches : false;

export const isTargetCategoryActive = (paramObj) => {
  const { targetID, currentActiveID, categories } = paramObj;

  const findParentCategory = (id) => {
    for (let i = 0; i < categories.length; i += 1) {
      const parentCategory = categories[i];
      for (let j = 0; j < parentCategory.child_categories.length; j += 1) {
        const childCategory = parentCategory.child_categories[j];
        if (childCategory.category_ID === id) {
          return parentCategory;
        }
      }
    }
    return null;
  };

  if (targetID === currentActiveID) return true;

  let matchedParentCategory = findParentCategory(currentActiveID);
  while (matchedParentCategory) {
    const matchedParentCategoryID = matchedParentCategory.category_ID;
    if (matchedParentCategoryID === targetID) return true;
    matchedParentCategory = findParentCategory(matchedParentCategoryID);
  }
  return false;
};

export const getProductCategoryId = (product) => {
  if(product.category){
    return product.category.category_ID;
  }
  return null;
};

export const getParentCategoryId = (category) => category.parent_category ? category.parent_category.category_ID : null;

export const toggleModal = (toggle) => {
  const element = document.getElementById('htmlRoot');
  if(toggle){
    element.classList.add('no-scroll');
  }else{
    element.classList.remove('no-scroll');
  }
}

export const getProductCategoryIds = (product) => {
  if(product.categories){
    return product.categories.map((category) => category.category_ID);
  }
  return null;
};


// WEBPACK FOOTER //
// ./src/lib/util.js